export const MINI_PDP_COLLECTION_SECTION_NAME_FOR_REF = 'mini-pdp-collection'
